"use strict";var i=require("./isFunction.cjs"),n=require("./isNonNullObject.cjs");exports.isPromise=function(e){return!!e&&(n.isNonNullObject(e)||i.isFunction(e))&&"then"in e&&i.isFunction(e.then)};
//# sourceMappingURL=isPromise.cjs.map
